import moment from 'moment';

// NP20-828: Geteilte Validierungs-Helper zwischen PersonalDataComponent (Formular)
// und ConsultantComponent (Badge-Zaehler). Weichen die beiden voneinander ab,
// zeigt das Badge einen anderen Wert als das Save-Verhalten (Reviewer-Hinweis
// PR #617) — deshalb hier zentralisiert.

/**
 * True wenn der gespeicherte Jahrgang-String durch parseJahrgang() als
 * DD.MM.YYYY oder YYYY erkannt werden kann. Spiegelt exakt die Logik aus
 * PersonalDataComponent.parseJahrgang.
 */
export function isValidJahrgang(value: string | undefined | null): boolean {
  if (!value) return false;
  const fullDate = moment(value, 'DD.MM.YYYY', true);
  if (fullDate.isValid()) return true;
  const yearOnly = moment(value, 'YYYY', true);
  return yearOnly.isValid();
}

/**
 * True wenn der Security-Check ausgelaufen ist (completedOn + 60 Monate liegt in
 * der Vergangenheit). Spiegelt PersonalDataComponent.isSecurityCheckExpired.
 */
export function isSecurityCheckExpired(completedOn: string | Date | null | undefined): boolean {
  if (!completedOn) return false;
  const expiry = new Date(completedOn);
  expiry.setMonth(expiry.getMonth() + 60);
  return expiry < new Date();
}
